export const checkURLHash = () => typeof window !== 'undefined' && window.location.hash;
